import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Helpers from '@Apis/helpers';
import PropTypes from 'prop-types';
import PurchaseOrdersList from './PurchaseOrdersList';
import './style.scss';

/**
 *
 */
class PurchaseOrders extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    const key = Helpers.getValueFromUrl('tab');
    return {
      ...state,
      currentTab: Number(key) || 1,
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <div className="po__home-wrapper">
          <PurchaseOrdersList />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({

});

PurchaseOrders.propTypes = {
  showCart: PropTypes.any,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrders));
